import { createFileRoute } from '@tanstack/react-router';
import { AppShell } from '../components/layout/AppShell.js';

// Auth is enforced per-page (see e.g. _player.wallet.tsx). The shell itself
// is public so unauth users can browse /casino. AppShell gates its
// wallet/member queries on the auth state.
export const Route = createFileRoute('/_player')({
  component: AppShell,
});
